import React from 'react';
import PropTypes from 'prop-types';

import CaregiverNameView from './CaregiverNameView';
import CaregiverNameEdit from './CaregiverNameEdit';

const CaregiverName = (props) => {
  const [isEditing, setIsEditing] = React.useState(false);

  const {
    caregiverData,
    caregiverBackend,
  } = props;

  return (
    <>
      <CaregiverNameView
        caregiverData={caregiverData}
        caregiverBackend={caregiverBackend}
        isEditing={isEditing}
        setIsEditing={setIsEditing}
      />
      {
        isEditing &&
        <CaregiverNameEdit
          caregiverData={caregiverData}
          caregiverBackend={caregiverBackend}
          isEditing={isEditing}
          setIsEditing={setIsEditing}
        />
      }
    </>
  );
};

CaregiverName.propTypes = {
  caregiverData: PropTypes.object.isRequired,
  caregiverBackend: PropTypes.object.isRequired,
};

export default React.memo(CaregiverName);
